var Web3 = require('./lib/web3');

// dont override global variable
if (typeof window !== 'undefined' && typeof window.Web3 === 'undefined') {
    window.Web3 = Web3;
}

module.exports = Web3;



//////////////////
// WEBPACK FOOTER
// ./~/web3/index.js
// module id = 924
// module chunks = 0